import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "catalogue-product-variant--placeholder placeholder"
}
const _hoisted_2 = {
  key: 1,
  class: "catalogue-product-variant--container",
  style: {"font-size":"75%"}
}
const _hoisted_3 = { class: "product-variant--ids meta" }
const _hoisted_4 = {
  key: 0,
  class: "product-variant--sku"
}
const _hoisted_5 = { class: "product-variant--ean" }
const _hoisted_6 = {
  key: 0,
  class: "product-variant--catalogue-details column",
  style: {"display":"flex"}
}
const _hoisted_7 = { class: "row" }
const _hoisted_8 = {
  class: "active-toggle",
  style: {"display":"inline-flex","margin-top":"-7px","margin-bottom":"0","padding-left":"10px","height":"15px"}
}
const _hoisted_9 = {
  key: 1,
  class: "product-variant--catalogue-placeholder",
  style: {"display":"flex"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_popup_edit = _resolveComponent("q-popup-edit")!
  const _component_form_input = _resolveComponent("form-input")!
  const _component_toggle = _resolveComponent("toggle")!

  return (!_ctx.entry)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, "..."))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
        _cache[4] || (_cache[4] = _createElementVNode("div", { class: "product-variant--img" }, null, -1)),
        _createElementVNode("div", _hoisted_3, [
          (_ctx.catalogueVariant)
            ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.skuController.display(_ctx.catalogueVariant.sku)) + " — ", 1))
            : _createCommentVNode("", true),
          _createElementVNode("span", _hoisted_5, _toDisplayString((_ctx.entry.ean || []).join(', ')), 1)
        ]),
        _createElementVNode("h6", {
          class: _normalizeClass(["bold product-variant--title", {highlight: _ctx.catalogueVariant?.active, disabled: !_ctx.catalogueVariant?.active}])
        }, [
          _createTextVNode(_toDisplayString(_ctx.catalogueVariant?.title || _ctx.entry.title), 1),
          (_ctx.catalogueVariant)
            ? (_openBlock(), _createBlock(_component_q_popup_edit, {
                key: 0,
                modelValue: _ctx.catalogueVariant.title,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.catalogueVariant.title) = $event)),
                "auto-save": ""
              }, {
                default: _withCtx((scope) => [
                  _createVNode(_component_q_input, {
                    modelValue: scope.value,
                    "onUpdate:modelValue": ($event: any) => ((scope.value) = $event),
                    dense: "",
                    autofocus: "",
                    counter: "",
                    onKeyup: _withKeys(e => {scope.set(e); }, ["enter"])
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "onKeyup"])
                ]),
                _: 1
              }, 8, ["modelValue"]))
            : _createCommentVNode("", true)
        ], 2),
        (_ctx.catalogueVariant)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_form_input, {
                  class: "mini",
                  modelValue: _ctx.catalogueVariant.price,
                  "onUpdate:modelValue": [
                    _cache[1] || (_cache[1] = ($event: any) => ((_ctx.catalogueVariant.price) = $event)),
                    _ctx.updatePrice
                  ],
                  type: "currency",
                  "data-currency": "€"
                }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_toggle, {
                    modelValue: _ctx.catalogueVariant.active,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.catalogueVariant.active) = $event)),
                    label: _ctx.catalogueVariant.active ? 'included' : 'not included',
                    onToggle: _ctx.toggleActive
                  }, null, 8, ["modelValue", "label", "onToggle"])
                ])
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createVNode(_component_toggle, {
                modelValue: _ctx.triggerActivate,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.triggerActivate) = $event)),
                label: _ctx.triggerActivate ? 'adding...' : 'not included',
                onToggle: _ctx.emitAdd
              }, null, 8, ["modelValue", "label", "onToggle"])
            ]))
      ]))
}